import React from 'react';
import './Statistic.css';
import Layout from '../Layout';
import { useNavigate } from 'react-router';
import { Chart1, Chart2, StatContainer } from './OrderComponent';

export function Statistic() 
{
    
  const navigate = useNavigate();

  return (

    <Layout activeMenu={1}>
    
      <div className='container-fluid'>
        <div className="row justify-content-center mb-5 mt-4">
          <div className="col-md-11">       

            {/* Fil d'Ariane / Titre */}
            <div className="row bg-white border py-4 text-center mb-4">
              <h1 className="fw-bold display-6 text-muted"> Dashboard commande </h1>
              <nav className="breadcrumb-nav">
                <span className="text-muted"> Statistique </span>
              </nav>
            </div>

            {/* Barre de Filtres et Contrôles */}
            <div className="row mb-4 g-4 mt-2">
              <div className="d-flex gap-3 flex-column flex-md-row justify-content-between align-items-center border-bottom pb-3 mb-4">
                {/* Vue Grille/Liste */}
                <div className="d-flex align-items-center gap-3 display-controls">
                  <span className="text-secondary lead"><i className="bi bi-grid-3x3-gap-fill"></i></span>
                  <span className="text-muted lead"> La gestion des commandes </span>
                </div>
                {/* Infos et Tris */}
                <div>
                  <button onClick={() => navigate(-1)} className='btn btn-sm btn-outline-dark px-3'> Retour <i className="bi bi-chevron-right ms-1"></i> </button>
                </div>
              </div>
            </div>

            {/* Cartes de Statistiques */}
            <StatContainer />

            {/* Graphe Mensuel */}
            <Chart1 />

            {/* Graphe Annuel */}
            <Chart2 />

          </div>
        </div>
      </div>

    </Layout>
  );
};


